/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ text: NonNullable<unknown> }} Fix_LineInputs */

const en_fix_line = /** @type {(inputs: Fix_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In the recipe: "${i?.text}"`)
};

const de_fix_line = /** @type {(inputs: Fix_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Im Rezept: „${i?.text}“`)
};

/**
* | output |
* | --- |
* | "In the recipe: \"{text}\"" |
*
* @param {Fix_LineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_line = /** @type {((inputs: Fix_LineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_LineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_line(inputs)
	return en_fix_line(inputs)
});